import { useShouldShowMaintenanceBanner } from '@ui/components/Layout/hooks/useShouldShowMaintenanceBanner';
import { Body } from '@ui/features/Trade/components/Body';
import { TradeModuleModal } from '@ui/features/Trade/components/TradeModule/TradeModuleModal';
import { TradeModuleProvider } from '@ui/features/Trade/components/TradeModuleConfirm/hooks/useTradeModuleContext';
import { TRADE_PAGE_BODY_ID } from '@ui/features/Trade/constants';
import dynamic from 'next/dynamic';
import { Box, Flex, FlexProps, Spacer } from 'styled-system/jsx';
import { cq } from 'styled-system/patterns';

import { CakepadLeverupBanner } from './CakepadLeverupBanner';
import { Head } from './Head';
import { StatSection } from './StatSection';

// const HolidayNotificationBannerLazy = dynamic(
//   () =>
//     import('@ui/features/RWA/components/HolidayNotificationBanner').then(
//       (mod) => mod.HolidayNotificationBanner,
//     ),
//   { ssr: false },
// );

export const Trade = (p: FlexProps) => {
  const shouldShowMaintenanceBanner = useShouldShowMaintenanceBanner();

  return (
    <Flex
      flexDir="column"
      position="relative"
      minH={{
        base: '100vh',
        desktop: shouldShowMaintenanceBanner
          ? 'layout.contentHeightWithAnnouncement'
          : 'layout.contentHeight',
      }}
      {...p}
      id={TRADE_PAGE_BODY_ID}
      css={cq.raw({
        containerName: 'trade-page-body',
        containerType: 'inline-size',
      })}
    >
      <Box h="full">
        <Head
          position="sticky"
          zIndex={10}
          top={0}
          display={{
            base: 'flex',
            desktop: 'none',
          }}
        />
        {/* <Box
          display={{
            base: 'none',
            desktop: 'block',
          }}
        >
          <CakepadLeverupBanner />
        </Box> */}
        {/* <HolidayNotificationBannerLazy /> */}
        <StatSection />
        <Body />
      </Box>

      {/* spacer to fill empty space if page height < 100vh, make sure sticky works */}
      {/* <Spacer /> */}
      <TradeModuleProvider>
        <TradeModuleModal
          minH="44px"
          position="sticky"
          zIndex="docked"
          bottom={0}
          w="full"
          // hide at CSS level too: the JS container check can stay pending and
          // the 44px minH bar would push the desktop terminal into page scroll
          display={{ base: 'flex', desktop: 'none' }}
        />
      </TradeModuleProvider>
    </Flex>
  );
};
